import React from "react";
import classNames from "classnames";

import { compose } from "redux";
import withTranslations from "../../../../../../hocs/withTranslations";
import useVoting from "../../../../../../hooks/useVoting";
import LandingTypography from "../../../../landingPage/pages/Homepage/components/LandingTypography";
import VotingButton from "../../VotingButton";
import useIsDesktop from "../../../../landingPage/hooks/useIsDesktop";
import { showModal } from "../../../../../../lib/react-redux-modal-provider";
import VotingInstructions from "../../VotingInstructions";

const VotingBanner = ({ translate, stockId }) => {
  const isDesktop = useIsDesktop();
  const { voted, toggleVote, loading } = useVoting(stockId);

  return (
    <LandingTypography>
      <div
        className={classNames(
          "flex flex-row justify-between align-center bg-gray-5 py-3 px-4",
          { "gap-10 rounded-1": isDesktop, "gap-5": !isDesktop }
        )}
      >
        <div
          className={classNames("flex", {
            "flex-row gap-6 align-center": isDesktop,
            "flex-col gap-1": !isDesktop
          })}
        >
          <strong
            className={classNames("line-height-130 text-black font-semibold", {
              "text-base shrink-0": isDesktop,
              "text-sm": !isDesktop
            })}
          >
            {translate("voting-banner_title")}
          </strong>
          <p
            className={classNames("line-height-140 mb-0", {
              "text-xs": isDesktop,
              "text-xs.3": !isDesktop
            })}
          >
            <span className={"text-black-5"}>
              {translate("voting-banner_paragraph")}{" "}
            </span>
            <span>
              <button
                className={
                  "underline font-medium text-black inline border-none bg-unset p-0 text-left"
                }
                onClick={() => {
                  showModal("NewModal", {
                    title: translate("voting-modal_title"),
                    children: <VotingInstructions />
                  });
                }}
              >
                {translate("voting-banner_learn-more")}
              </button>
            </span>
          </p>
        </div>
        <div className={classNames({ "shrink-0": isDesktop })}>
          <VotingButton
            onClick={toggleVote}
            checked={Boolean(voted)}
            loading={loading}
          />
        </div>
      </div>
    </LandingTypography>
  );
};

export default compose(withTranslations)(VotingBanner);
